
import ReactHTMLTableToExcel from "react-html-table-to-excel"
import moment from "moment";

export const GardenReopenPendingExport = (props) => {
    const { ExcelData, name, searchName } = props
    return (
        <div style={{ display: 'inline', marginLeft: '0px' }}>
            <ReactHTMLTableToExcel
                id="test-table-xls-button"
                table="table-to-FarmerMasterExport"
                className="btn btn-primary float-end download-table-xls-button float-end btn btn-export btn-md mr-1 mb-1 ml-1"
                filename={name}
                sheet={name}
                buttonText="Export"
                style={{ borderColor: 'black' }}
            />
            <table id="table-to-FarmerMasterExport" style={{ display: 'none', width: '100%' }}>

                <h5><span>&emsp;</span></h5>

                <h4 style={{ textAlign: 'center', fontSize: 16 }}>{name}</h4>

                <tr><td></td></tr>

                <thead className="thead-dark" >
                    <tr style={{ backgroundColor: '#254462', color: "#fff", border: '1px solid white' }}>
                        <th>Sr.No.</th>
                        {
                            searchName == 'Reopen Pending' ?
                                <>
                                    <th>Work Done Date</th>
                                    <th>Reopen Date</th>
                                </>
                                :
                                <>
                                    <th>Work Reopen Date</th>
                                    <th>Reopen Completed Work Date</th>
                                </>

                        }

                        <th>Asset Name</th>
                        <th>Sector Name	 </th>
                        <th>Area</th>
                        <th>Work Name </th>
                    </tr>
                </thead>
                <tbody>
                    {
                        ExcelData && ExcelData.table && ExcelData.table.length > 0 ? ExcelData.table.map((item, i) => (
                            <tr style={{ textAlign: "center" }}>
                                <td >{item.rowNum}</td>
                                {
                                    searchName == 'Reopen Pending' ?
                                        <>
                                            <td>{item.workDate ? moment(item.workDate).format("DD-MM-YYYY") : '-'}</td>
                                            <td>{item.reopenWorkDate ? moment(item.reopenWorkDate).format("DD-MM-YYYY") : '-'}</td>
                                        </>
                                        :
                                        <>
                                            <td>{item.reopenWorkDate ? moment(item.reopenWorkDate).format("DD-MM-YYYY") : '-'}</td>
                                            <td>{item.reopenWorkCompletedDate ? moment(item.reopenWorkCompletedDate).format("DD-MM-YYYY") : '-'}</td>
                                        </>

                                }

                                <td>{item.assetName ? item.assetName : '-'}</td>
                                <td>{item.sectorName ? item.sectorName : '-'}</td>
                                <td>{item.areaName ? item.areaName : '-'}</td>
                                <td>{item.workname ? item.workname : '-'}</td>

                            </tr>
                        )) : <tr>No data</tr>
                    }
                </tbody>
            </table>
        </div>
    )
}